import { Button } from '@mui/material';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useNotification from 'hooks/useNotification';
import React, { Fragment, useState } from 'react';
import DeleteConfirmDialog from './DisconnectDialog';
import { useTranslation } from 'react-i18next';

const DisconnectButton = ({ link = '', data = {}, refetch, icon }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const sendNotification = useNotification();

  const handleAction = (action) => {
    if (action == 'cancel') setOpen(false);
    if (action == 'delete') {
      setLoading(true);
      axiosPrivate
        .post(link, { data: data })
        .then((result) => {
          if (result.data && result.data.status) {
            sendNotification({
              msg: t('common.alerts.success.delete'),
              variant: 'success',
            });
            setOpen(false);
            refetch();
          }
        })
        .catch((err) => {
          sendNotification({
            msg: t('common.alerts.error.delete'),
            variant: 'error',
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Fragment>
      <Button
        color='error'
        aria-label='delete'
        size='small'
        sx={{ minWidth: 40, width: 40 }}
        onClick={() => setOpen(true)}
      >
        {icon ? icon : <i className='bi bi-trash3' />}
      </Button>
      <DeleteConfirmDialog
        open={open}
        setOpen={setOpen}
        handleAction={handleAction}
        loading={loading}
      />
    </Fragment>
  );
};

export default DisconnectButton;
